import { createContext } from 'react';

export interface IPaginationContext {
  /** An object with keys for the filtered field and values for the value to filter on. */
  filter?: {
    [key: string]: undefined | string | number | boolean;
  };
  /** The field to sort the content by */
  sort?: string[];
  /** The current page number */
  page?: number;
  /** The current page limit */
  limit?: number;
  /** Sets the filter */
  setFilter: React.Dispatch<React.SetStateAction<IPaginationContext['filter']>>;
  /** Sets the pagenumber */
  setPage: React.Dispatch<React.SetStateAction<IPaginationContext['page']>>;
  /** Sets sets the page limit */
  setLimit: React.Dispatch<React.SetStateAction<IPaginationContext['limit']>>;
  /** Sets the sorting value */
  setSort: React.Dispatch<React.SetStateAction<IPaginationContext['sort']>>;
  /** Toggles sort from ascending, to descending, to none */
  toggleSortBy: (sortBy: string) => void;
}

export const PaginationContext = createContext<null | IPaginationContext>(null);
